/**
 * React Query hooks for the outgoing mail server (Administration › Courriels).
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "@/api/client";
import type { MailSettings, MailSettingsInput, MailTestResult } from "@/api/types";

const SETTINGS_KEY = ["mail", "settings"];

export function useMailSettings() {
  return useQuery({
    queryKey: SETTINGS_KEY,
    queryFn: () => api.get<MailSettings>("/admin/mail"),
  });
}

export function useSaveMailSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: MailSettingsInput) => api.put<MailSettings>("/admin/mail", input),
    onSuccess: (settings) => {
      queryClient.setQueryData(SETTINGS_KEY, settings);
    },
  });
}

export function useSendTestMail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (recipient: string) => api.post<MailTestResult>("/admin/mail/test", { recipient }),
    onSettled: () => {
      // The test records its outcome on the settings
      void queryClient.invalidateQueries({ queryKey: SETTINGS_KEY });
    },
  });
}
